/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Event_In_ProgressInputs */



/**
* | output |
* | --- |
* | "This event is currently being played." |
*
* @param {Tournament_Event_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_event_in_progress = /** @type {((inputs?: Tournament_Event_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Event_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cet événement est actuellement en cours.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este evento está actualmente en curso.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este evento está atualmente em andamento.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo evento è attualmente in corso.")
	return /** @type {LocalizedString} */ ("This event is currently being played.")
});